import React from 'react';
import { View } from 'react-native';

import { useThemedStyles } from '../../hooks/useThemedStyles';
import SegmentedControl from './SegmentedControl';

/**
 * SegmentedTabBar: SegmentedControl as the `tabBar` of a material top-tab
 * navigator (`tabBar={props => <SegmentedTabBar {...props} />}`). Presses
 * follow the navigator's tabPress contract, so lazy loading and tab state
 * behave as with the default bar. Labels come from options.tabBarLabel.
 */
const SegmentedTabBar = ({ state, descriptors, navigation }) => {
	const styles = useThemedStyles(createStyles);
	const options = state.routes.map(route => ({
		value: route.key,
		label: descriptors[route.key]?.options?.tabBarLabel || route.name,
	}));

	const selectTab = (routeKey) => {
		const route = state.routes.find(item => item.key === routeKey);
		const event = navigation.emit({
			type: 'tabPress',
			target: route.key,
			canPreventDefault: true,
		});

		if (!event.defaultPrevented) {
			navigation.navigate(route.name, route.params);
		}
	};

	return (
		<View style={styles.container}>
			<SegmentedControl
				role="tab"
				options={options}
				value={state.routes[state.index]?.key}
				onChange={selectTab}
			/>
		</View>
	);
};

const createStyles = ({ ui: { space } }) => ({
	container: {
		paddingHorizontal: space.gutter,
		paddingBottom: space.md,
	},
});

export default SegmentedTabBar;
